import React, { useState, useEffect } from "react";
import "../styles/products.css";
import axios from "axios";
import { serverUrl } from "../utils/Constants";
import ImageMagnifier from "../components/ImageMagnifier";

export default function Products({ heading }) {
  const [loading, setLoading] = useState(true);
  const [products, setProducts] = useState([]);

  useEffect(() => {
    setProducts([]);
    setLoading(true);
    try {
      axios.get(`${serverUrl}/get-data.php?productType=${encodeURIComponent(heading)}`).then((response) => {
        setProducts(response.data);
        setLoading(false);
      });
    } catch (error) {
      console.error("Error fetching products:", error);
      setLoading(false);
    }
  }, [heading]);

  function MyComponent({ _index, data }) {
    const [index, setIndex] = useState(0);
    const [showModal, setShowModal] = useState(false);
    const [modalIndex, setModalIndex] = useState(0); // Index for modal slider

    const handleImageClick = (clickedIndex) => {
      setModalIndex(clickedIndex);
      setShowModal(true);
    };

    const handleClose = () => {
      setShowModal(false);
    };

    let nextBtn;
    let prevBtn;

    function nextImage() {
      nextBtn = document.getElementById(`n${_index}`);
      prevBtn = document.getElementById(`p${_index}`);
      const updateToValue = index + 1;
      setIndex(updateToValue);
      if (updateToValue === data.img_count - 1) {
        nextBtn.style.display = "none";
        prevBtn.style.display = "inline-block";
      }
    }

    function prevImage() {
      nextBtn = document.getElementById(`n${_index}`);
      prevBtn = document.getElementById(`p${_index}`);
      const updateToValue = index - 1;
      setIndex(updateToValue);
      if (updateToValue === 0) {
        nextBtn.style.display = "inline-block";
        prevBtn.style.display = "none";
      }
    }

    const nextModalImage = () => {
      if (modalIndex < data.img_count - 1) {
        setModalIndex((m) => m + 1);
      }
    };

    const prevModalImage = () => {
      if (modalIndex > 0) {
        setModalIndex((m) => m - 1);
      }
    };

    const img_desc = data.img_desc.split(",");
    // full URL used in both <img> and lens background
    const modalImgUrl = `/images/products/${encodeURIComponent(data.img_src_name[modalIndex])}`;

    return (
      <>
        <div className="row" style={{ marginBottom: "50px" }}>
          <div className="col-lg-4 col-sm-12">
            <div className="image-slide">
              {data.img_count > 1 && (
                <button id={`p${_index}`} onClick={prevImage} className="btn-prev">
                  <iconify-icon icon="ep:arrow-left-bold" class="pt-1" />
                </button>
              )}
              <img
                key={data.title}
                src={`/images/products/${data.img_count > 1 ? data.img_src_name[index] : data.img_src_name[0]}`}
                className="cover"
                height="230"
                width="230"
                alt="products"
                onClick={() => handleImageClick(index)}
                style={{ cursor: "zoom-in" }}
              />
              <div style={{ padding: "0px 35px" }}>
                <div className="product-text-wrap" style={{ borderBottom: "4px solid #0dc0c0" }}>
                  {img_desc[0]}
                  <br />
                  {img_desc[1]}
                </div>
              </div>
              {data.img_count > 1 && (
                <button id={`n${_index}`} onClick={nextImage} className="btn-next">
                  <iconify-icon icon="ep:arrow-right-bold" class="pt-1" />
                </button>
              )}
            </div>
          </div>
          <div className="col-lg-8 col-sm-12 product-details">
            <h4>{data.title}</h4>
            <ul className="add-border-padding">
              {data.desc.map((el) => {
                return (
                  <li key={el}>
                    <strong>-{el}</strong>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
        {showModal && (
          <div className="modal show d-block" tabIndex="-1" onClick={handleClose} style={{ backgroundColor: "#f3f3f3a3" }}>
            <div className="modal-dialog modal-dialog-centered">
              <div
                className="modal-content"
                onClick={(e) => e.stopPropagation()}
                style={{ height: "80vh", display: "flex", flexDirection: "column" }}
              >
                <div className="modal-header" style={{ backgroundColor: "#0dc0c0" }}>
                  <h5 className="modal-title flex-grow-1 text-center">
                    <b>Image Preview</b>
                  </h5>
                  <button type="button" className="btn-close" onClick={handleClose}></button>
                </div>
                <div
                  className="modal-body position-relative"
                  style={{
                    flex: "1 1 auto",
                    overflow: "hidden",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    boxSizing: "border-box",
                  }}
                >
                  {data.img_count > 1 && modalIndex > 0 && (
                    <button
                      onClick={prevModalImage}
                      className="btn btn-light position-absolute"
                      style={{ top: "50%", left: "10px", transform: "translateY(-50%)" }}
                    >
                      <iconify-icon icon="ep:arrow-left-bold" />
                    </button>
                  )}

                  <div
                    style={{
                      // This height is relative to the modal-content (80vh). Using 100% is fine because modal-body flexes.
                      height: "100%", // take full available body height
                      maxHeight: "calc(80vh - 120px)", // ensure safe gap for header/footer + padding
                      width: "100%",
                      maxWidth: "100%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      margin: "0 auto",
                      overflow: "hidden",
                      boxSizing: "border-box",
                    }}
                  >
                    {/* <ImageMagnifier src={modalImgUrl} zoom={1.6} size={window.innerWidth < 768 ? 100 : 140} /> */}
                    <ImageMagnifier src={modalImgUrl} zoom={1.6} size={140} />
                  </div>

                  {data.img_count > 1 && modalIndex < data.img_count - 1 && (
                    <button
                      onClick={nextModalImage}
                      className="btn btn-light position-absolute"
                      style={{ top: "50%", right: "10px", transform: "translateY(-50%)" }}
                    >
                      <iconify-icon icon="ep:arrow-right-bold" />
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </>
    );
  }

  return (
    <>
      <section id="products">
        <div className="mcare-products">
          <div className="container">
            <h2 className="mb-6 text-center">{heading}</h2>
            <div className="product-wrapper">
              {loading ? (
                <p className="text-center fs-4">Loading...</p>
              ) : (
                products?.map((arrEl, i, _) => <MyComponent key={i} _index={i} data={arrEl} />)
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
